import * as React from "react";
import {RouteComponentProps} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {initialNach} from "consent/actions";
import {DocTypes, getContentType} from "userform/utils";
import {uploadNach} from "documents/actions";
import {getLatestLoanOpp} from "consent/actions";
import {downloadPDF} from "insurance/utils";
import Loading from "components/loading";
import DocInput from "components/docInput";
import ConsentBox from "consent/utils/consentBox";
import IconButton from "components/iconButton";
import {imageBaseUrl} from "config";
import VerticalDashLine from "consent/utils/verticalDashLine";
import TextContainer from "consent/utils/textContainer";
import RoundedButton from "components/roundedButton";
import {Base64} from "node-forge";
import {history} from "load/store";

interface IConnectProps {
  userId: number;
  oppId: string;
  dispatch?: (action: any) => void;
  nachLink: string;
  isNachUploaded: boolean;
  isAndroid: boolean;
  initiationNachError: string;
  isPartnerAndroid: boolean;
  documentUploaded: boolean;
}

interface IState {
    file: Base64;
    currentPath: string;
}

class NachUpload extends React.Component<IConnectProps & RouteComponentProps, IState> {

    constructor(props) {
        super(props);
        this.handleUpload = this.handleUpload.bind(this);
        this.handleFileInput = this.handleFileInput.bind(this);
        this.state = {
            file: null,
            currentPath:  this.props.location.pathname,
        };
    }

    public handleFileInput(file, type) {
        this.setState({
            file,
        });
    }

    public handleUpload(userId: number, b64: Base64, docType: DocTypes, opportunityId: string, applicationId: number) {
        const fileType = getContentType(b64);
        if (fileType !== null) {
            this.props.dispatch(uploadNach(fileType.mime, docType, userId, b64, opportunityId));
        }
    }

  public componentWillMount(): void {
    if (!this.props.nachLink) {
      this.props.dispatch(initialNach(this.props.oppId, "PNACH"));
    }
  }
  public componentWillReceiveProps(nextProps): void {
    if (!this.props.documentUploaded && nextProps.documentUploaded) {
      this.props.dispatch(getLatestLoanOpp(this.props.oppId));
    }
    if (this.props.initiationNachError !== nextProps.initiationNachError) {
        history.goBack();
    }
  }

    public renderFileInput() {
        return (<DocInput primaryLabel="Select NACH Document"
                          type={DocTypes.NACH}
                          handleFileInput={(b64, type) => this.handleFileInput(b64, type)}/>);
    }

    public render() {
        const loading = this.props.nachLink === null;
        return (
            <div>
                <Loading active={loading}/>
                <ConsentBox pageTitle="Scan & Upload" showBackButton={true}>
                    <div className="flex-column-center-row">
                        <IconButton
                            buttonText="Download NACH"
                            iconUrl={`${imageBaseUrl}/img/consent/download_icon.png`}
                            onClick={() => downloadPDF(this.props.nachLink,
                                "Nach_Form",
                                (this.props.isAndroid && !this.props.isPartnerAndroid))}
                        />
                        <VerticalDashLine dashNumber={3}/>
                        <TextContainer text="Print & Sign"/>
                        <VerticalDashLine dashNumber={3}/>
                        <TextContainer text="Scan the NACH"/>
                        <VerticalDashLine dashNumber={3}/>
                        {this.renderFileInput()}
                        <VerticalDashLine dashNumber={2}/>
                        <RoundedButton
                            buttonText="Upload"
                            size="small"
                            onClick={() => this.handleUpload(this.props.userId, this.state.file, DocTypes.NACH, this.props.oppId, this.props.applicationId)}
                        />
                    </div>
                </ConsentBox>
            </div>
        );
    }
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
  const loanApprovalInfo = state.consent.loanApprovalInfo;
  return {
    userId: state.login.auth ? state.login.auth.userId : null,
    oppId: state.consent.lenderOpportunityId ? state.consent.lenderOpportunityId : null,
    nachLink: loanApprovalInfo && loanApprovalInfo.nach ? loanApprovalInfo.nach.pnachLink : null,
    isNachUploaded: loanApprovalInfo && loanApprovalInfo.documentsConsentStatus ? loanApprovalInfo.documentsConsentStatus.isNachUploaded : null,
    initiationNachError: state.consent.initiationNachError,
    isAndroid: state.login.isAndroid,
    isPartnerAndroid: state.login.isPartnerAndroid,
    documentUploaded: state.documents.documentUploaded,
  };
};

export default connect<IConnectProps, {}, {}> (mapStateToProps)(NachUpload);
